import axiosClient from "./axiosClient";

export class GraphRequestBaseService {
  baseURL: string;
  expand: string;
  constructor(baseURL: string, fields: string[]) {
    this.baseURL = baseURL;
    this.expand = `expand=fields(select=${fields.join(",")})`;
  }
  getRequests(params?: { aflType?: string; department?: string[]; count?: number }) {
    var url = `${this.baseURL}?expand=fields`;
    var filterConditions = [];

    if (params?.aflType && params?.department) {
      const departments = params.department.map((dept) => `startswith(fields/eBranch, '${dept}')`);
      const departmentFilter = `(${departments.join(" or ")})`; // Grouping OR conditions for departments

      // Push both aflType and department filters with an AND condition
      filterConditions.push(`startswith(fields/eAFLType, '${params.aflType}') and ${departmentFilter}`);
    } else if (params?.aflType) {
      filterConditions.push(`startswith(fields/eAFLType, '${params.aflType}')`);
    } else if (params?.department) {
      const departments = params.department.map((dept) => `startswith(fields/eBranch, '${dept}')`);
      const filter = departments.join(" or ");
      filterConditions.push(filter);
    }

    //   else {
    //     filterConditions.push(`not startswith(fields/eDepartment, 'NBA')`);
    //     filterConditions.push(`not startswith(fields/department, 'DAD')`);
    // }

    if (filterConditions.length > 0) {
      url += `&filter=${filterConditions.join(" and ")}`;
    }

    if (params?.count && params.count > 0) {
      url += `&top=${params.count}`;
    }

    return axiosClient.get(url);
  }
  getRequest(id: string) {
    return axiosClient.get(`${this.baseURL}/${id}?expand=fields`);
  }
  create(request: any) {
    return axiosClient.post(this.baseURL, { fields: request });
  }
  update(id: string, data: any) {
    return axiosClient.patch(`${this.baseURL}/${id}/fields`, data);
  }
  delete(id: string) {
    return axiosClient.delete(`${this.baseURL}/${id}`);
  }
}
